import { render, staticRenderFns } from "./HaberKategori.vue?vue&type=template&id=63745a87&scoped=true&"
import script from "./HaberKategori.vue?vue&type=script&lang=js&"
export * from "./HaberKategori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63745a87",
  null
  
)

export default component.exports